import React, { useEffect, useState } from 'react';
import {
  Alert,
  Button,
  Grid,
  Snackbar,
  styled,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  OutlinedInput,
  Typography,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { Span } from 'app/components/Typography';
import { TextValidator, ValidatorForm } from 'react-material-ui-form-validator';
import { addPatients, updatePatient } from 'app/api-ws/patients-ws';
import CheckboxGrid from '../components/CheckboxGrid';
import useAuth from 'app/hooks/useAuth';

const TextField = styled(TextValidator)(() => ({
  width: '100%',
  marginBottom: '16px'
}));

const PatientForm = ({ doctorId, patient, handleCloseDialog, fetchPatientDetails }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [patientName, setPatientName] = useState(patient?.patientName);
  const { user } = useAuth();

  let date1 = new Date().toISOString().split('T')[0];
  if (patient && patient.date) {
    date1 = patient.date.split('T')[0];
  }
  const [date, setDate] = useState(date1);
  const [age, setAge] = useState(patient?.age);
  const [sex, setSex] = useState(patient?.sex);
  const [opdNo, setOpdNo] = useState(patient?.opdNo);
  const [phone, setPhone] = useState(patient?.phone);
  const [address, setAddress] = useState({
    buildingNo: patient?.address?.buildingNo || '',
    street: patient?.address?.street || '',
    locality: patient?.address?.locality || '',
    district: patient?.address?.district || '',
    state: patient?.address?.state || 'Karnataka',
    pincode: patient?.address?.pincode || ''
  });
  const [medicalHistory, setMedicalHistory] = useState(patient?.medicalHistory || []);
  const [otherMedicalHistory, setOtherMedicalHistory] = useState(patient?.otherMedicalHistory);
  const [medication, setMedication] = useState(patient?.medication || []);
  const [otherMedication, setOtherMedication] = useState(patient?.otherMedication);
  const [allergy, setAllergy] = useState(patient?.allergy);
  const [females, setFemales] = useState(patient?.females);
  const [tobacco, setTobacco] = useState(patient?.tobacco || []);

  const [open, setOpen] = useState(false);
  const [snackBarMessage, setSnackBarMessage] = useState('');
  const [snackBarType, setSnackBarType] = useState('success');

  const medicationList = [
    { label: 'Asprin', value: 'Asprin' },
    { label: 'Bisphosphorates', value: 'Bisphosphorates' },
    { label: 'Steroids', value: 'Steroids' },
    { label: 'Calcium Channel Blockers', value: 'Calcium Channel Blockers' },
    { label: 'Dilatin Sodium', value: 'Dilatin Sodium' },
    { label: 'Oral Contraceptives', value: 'Oral Contraceptives' }
  ];

  const medicalHistoryList = [
    { label: 'Diabetes', value: 'Diabetes' },
    { label: 'Hypertension', value: 'Hypertension' },
    { label: 'Cardiac Problem', value: 'Cardiac Problem' },
    { label: 'Asthma', value: 'Asthma' },
    { label: 'Epilepsy', value: 'Epilepsy' },
    { label: 'Gastritis', value: 'Gastritis' },
    { label: 'Thyroid', value: 'Thyroid' },
    { label: 'Organ Transplant', value: 'Organ Transplant' }
  ];

  const tobbacoList = [
    { label: 'Smoking', value: 'Smoking' },
    { label: 'Chewing', value: 'Chewing' },
    { label: 'Both', value: 'Both' },
    { label: 'None', value: 'None' }
  ];

  const handleSubmit = (event) => {
    const patientRequest = {
      patientName: patientName,
      age: age,
      sex: sex,
      date: date,
      opdNo: opdNo,
      phone: phone,
      refDoctorId: doctorId,
      address: {
        buildingNo: address.buildingNo,
        street: address.street,
        locality: address.locality,
        district: address.district,
        state: address.state,
        pincode: address.pincode
      },
      medicalHistory: medicalHistory,
      medication: medication,
      allergy: allergy,
      females: females,
      tobacco: tobacco,
      otherMedication: otherMedication,
      otherMedicalHistory: otherMedicalHistory
    };

    addPatients(patientRequest, user?.authToken)
      .then((res) => {
        // console.log(res);
        if (res.data.status === 'success') {
          setSnackBarMessage('Patient Added Successfully');
          setSnackBarType('success');
          showSnackBar();
          handleCloseDialog();
        } else {
          setSnackBarMessage('Error in adding Patient');
          setSnackBarType('error');
          showSnackBar();
        }
      })
      .catch((res) => {
        // console.log('Error2222', res.response?.data?.message);
        setSnackBarMessage(res.response.data.message);
        setSnackBarType('error');
        showSnackBar();
      });
    // console.log('submitted');
  };

  const updatePatientSubmit = async (event) => {
    const updatePatientRequest = {
      _id: patient?._id,
      patientName: patientName,
      age: age,
      sex: sex,
      date: date,
      opdNo: opdNo,
      phone: phone,
      address: {
        buildingNo: address.buildingNo,
        street: address.street,
        locality: address.locality,
        district: address.district,
        state: address.state,
        pincode: address.pincode
      },
      medicalHistory: medicalHistory,
      medication: medication,
      allergy: allergy,
      females: females,
      tobacco: tobacco,
      otherMedication: otherMedication,
      otherMedicalHistory: otherMedicalHistory
    };

    await updatePatient(updatePatientRequest, user?.authToken)
      .then((res) => {
        // console.log(res);
        if (res.data.status === 'success') {
          setSnackBarMessage('Patient updated Successfully');
          setSnackBarType('success');
          showSnackBar();
          fetchPatientDetails();
          handleCloseDialog();
        } else {
          setSnackBarMessage('Error in updating Patient');
          setSnackBarType('error');
          showSnackBar();
        }
      })
      .catch((res) => {
        // console.log('Error2222', res.response?.data?.message);
        setSnackBarMessage(res.response.data.message);
        setSnackBarType('error');
        showSnackBar();
      });
    // console.log('submitted');
  };

  function showSnackBar() {
    setOpen(true);
  }

  function handleClose(_, reason) {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  }

  const handleCheckboxChange = (event, selectedState) => {
    const value = event.target.value;

    selectedState((prevState) => {
      if (value === 'None') {
        return prevState.includes('None') ? [] : ['None'];
      } else {
        const newState = prevState.includes('None') ? [] : prevState;

        if (newState.includes(value)) {
          return newState.filter((item) => item !== value);
        } else {
          return [...newState, value];
        }
      }
    });
  };

  const generateOpdNo = (date, phone) => {
    const [year, month, day] = date.split('-');
    const formattedYear = year.slice(2);
    const formattedDay = day.padStart(2, '0');
    const formattedMonth = month.padStart(2, '0');
    const opdNo = `${formattedDay}${formattedMonth}${formattedYear}_${phone}`;
    setOpdNo(opdNo);
  };

  useEffect(() => {
    generateOpdNo(date, phone);
  }, [phone]);

  const handleNameChange = (e) => {
    const inputValue = e.target.value;

    const regex = /^[a-zA-Z\s]*$/;

    if (regex.test(inputValue)) {
      const capitalizedInput = inputValue.charAt(0).toUpperCase() + inputValue.slice(1);
      setPatientName(capitalizedInput);
    }
  };

  return (
    <div>
      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert
          onClose={handleClose}
          severity={snackBarType}
          sx={{ width: '100%' }}
          variant="filled"
        >
          {snackBarMessage}
        </Alert>
      </Snackbar>
      <Grid sx={{ paddingLeft: '2vh', paddingTop: '10px' }}>
        <ValidatorForm onSubmit={patient ? updatePatientSubmit : handleSubmit} onError={() => null}>
          <Grid container columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
            <Grid item xs={12}>
              <TextField
                type="text"
                name="Name"
                id="standard-basic"
                label="Name"
                variant="outlined"
                fullWidth
                value={patientName}
                onChange={handleNameChange}
                errorMessages={['this field is required']}
                validators={['required']}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                type="number"
                name="Age"
                id="standard-basic"
                label="Age"
                variant="outlined"
                fullWidth
                value={age}
                onChange={(e) => setAge(e.target.value)}
                errorMessages={['this field is required', 'Age must be above 1 Years']}
                validators={['required', 'minNumber:1']}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextValidator
                fullWidth
                select
                variant="outlined"
                label="Sex"
                name="sex"
                id="sex"
                value={sex}
                onChange={(e) => {
                  setSex(e.target.value);
                  setFemales(e.target.value === 'Female' ? females : '');
                }}
                errorMessages={['This field is required']}
                validators={['required']}
                InputProps={{ inputComponent: OutlinedInput }}
              >
                <MenuItem value="Male">Male</MenuItem>
                <MenuItem value="Female">Female</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </TextValidator>
            </Grid>

            <Grid item xs={12} sm={6} style={{ marginTop: isMobile ? '20px' : 0 }}>
              <TextField
                type="tel"
                name="phone"
                id="standard-basic"
                label="Phone"
                variant="outlined"
                fullWidth
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                validators={['required', 'isNumber', 'matchRegexp:^\\d{10}$', 'minNumber:1']}
                errorMessages={[
                  'This field is required',
                  'Must be a number',
                  'Phone number must be 10 digits',
                  'Must be a positive number'
                ]}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                type="date"
                name="date"
                id="standard-basic"
                variant="outlined"
                fullWidth
                value={date}
                disabled
                onChange={(e) => setDate(e.target.value)}
                errorMessages={['This field is Required']}
                validators={['required']}
              />
            </Grid>

            <Grid item xs={7}>
              <h4>Patient Address</h4>
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                type="text"
                name="BuildingNumber"
                id="standard-basic"
                value={address.buildingNo}
                onChange={(val) => setAddress({ ...address, buildingNo: val.target.value })}
                label="Door Number"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                type="text"
                name="StreetAddress"
                id="standard-basic"
                value={address.street}
                onChange={(val) => setAddress({ ...address, street: val.target.value })}
                label="Street"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                type="text"
                name="Locality"
                id="standard-basic"
                value={address.locality}
                onChange={(val) => setAddress({ ...address, locality: val.target.value })}
                label="Locality"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                type="text"
                name="District"
                id="standard-basic"
                value={address.district}
                onChange={(val) => setAddress({ ...address, district: val.target.value })}
                label="District"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                type="text"
                name="State"
                id="standard-basic"
                value={address.state}
                onChange={(val) => setAddress({ ...address, state: val.target.value })}
                errorMessages={['this field is required']}
                label="State"
                validators={['required']}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                type="number"
                name="Pincode"
                id="standard-basic"
                value={address.pincode}
                onChange={(val) => setAddress({ ...address, pincode: val.target.value })}
                errorMessages={['this field is required', 'Pincode must be 6 Characters']}
                label="Pincode"
                validators={['required', 'matchRegexp:^\\d{6}$']}
              />
            </Grid>

            <Grid item xs={12}>
              <CheckboxGrid
                items={medicationList}
                selectedValues={medication}
                onCheckboxChange={(event) => handleCheckboxChange(event, setMedication)}
                category="Medication"
                category1="Patient is On:"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                type="text"
                name="OtherMedication"
                id="standard-basic"
                label="Other Medication"
                variant="outlined"
                fullWidth
                value={otherMedication}
                onChange={(e) => setOtherMedication(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <TextField
                type="text"
                name="allergy"
                id="standard-basic"
                label="Allergy"
                variant="outlined"
                fullWidth
                value={allergy}
                onChange={(e) => setAllergy(e.target.value)}
              />
            </Grid>

            <Grid item xs={12}>
              <CheckboxGrid
                items={tobbacoList}
                selectedValues={tobacco}
                onCheckboxChange={(event) => handleCheckboxChange(event, setTobacco)}
                category="Tobacco"
              />
            </Grid>

            <Grid item xs={12}>
              <CheckboxGrid
                items={medicalHistoryList}
                selectedValues={medicalHistory}
                onCheckboxChange={(event) => handleCheckboxChange(event, setMedicalHistory)}
                category="Medical History"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <TextField
                type="text"
                name="OtherMedicalHistory"
                id="standard-basic"
                label="Other Medical History"
                variant="outlined"
                fullWidth
                value={otherMedicalHistory}
                onChange={(e) => setOtherMedicalHistory(e.target.value)}
              />
            </Grid>

            {sex === 'Female' && (
              <Grid item xs={12}>
                <FormControl fullWidth variant="outlined">
                  <InputLabel htmlFor="females">Female is</InputLabel>
                  <Select
                    value={females}
                    onChange={(e) => {
                      setFemales(e.target.value);
                    }}
                    label="Females"
                    input={<OutlinedInput label="Females" name="females" id="females" />}
                  >
                    <MenuItem value="Pregnant">Pregnant</MenuItem>
                    <MenuItem value="FeedingMother">Feeding Mother</MenuItem>
                    <MenuItem value="">None</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
            )}
          </Grid>
          <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '2vh' }}>
            <Button onClick={handleCloseDialog} color="primary">
              <Typography color="#66b5a3">Cancel</Typography>
            </Button>
            <Button
              color="primary"
              variant="contained"
              type="submit"
              style={{ backgroundColor: '#66b5a3', color: 'white' }}
            >
              <Span sx={{ pl: 1, textTransform: 'capitalize' }}>
                {patient ? 'Save Changes' : 'Add Patient'}
              </Span>
            </Button>
          </div>
        </ValidatorForm>
      </Grid>
    </div>
  );
};

export default PatientForm;
